<template>
  <div class="home_wrapper">
    <div class="homepage-head">
      <h1 class="homepage-title">Expand the benefits of allergy immunotherapy to more patients: Patient Cases</h1>
    </div>
    <div class="patients-list">
      <div v-for="patient in this.patients" :key="patient.id"
           @click="onSelectItem(patient.slug)"
           @mouseenter="onMouseEnter"
           @mouseleave="onMouseLeave"
           :id="'patient_' + patient.slug"
           :class="['patient_item','patient_item-' + patient.slug , {'patient_selected': selected === patient.slug}]">
        <div class="patient_item__container">
          <div class="patient_images">
            <div :class="['patient_circle', 'patient_circle-' + patient.id]"
                 v-if="userAgent.window.width > 1024 || (userAgent.window.width <= 1024 && userAgent.orientation === 'landscape')">
              <div :class="['patient_image', 'patient_image-' + patient.id]"
                   :style="{ backgroundImage: 'url(' + patient.image + ')' }"></div>
            </div>
            <img v-else class="patient_item__image" :src="patient.mobileImage" alt/>
          </div>
          <div class="patient_bg"></div>
          <div class="patient_name">
            <p class="patient-name" v-html="patient.name + '*'"></p>
          </div>
          <div class="patient_description">
            <p class="patient-description" v-html="patient.description"></p>
          </div>
          <div class="patient_button">
            <a href="javascript:void(0);" class="button-arrow no-hover">
                <span :class="['button', 'read-story', 'unselectable']"
                      :id="patient.name.toLowerCase() + '_button_text'">Read Story&nbsp;&nbsp;&nbsp;</span>
              <img alt class="arrow-right" src="@/assets/img/homepage/arrow-right.svg"/>
            </a>
          </div>
          <div class="patient_health">
            <div class="patient_health-left">
              <p v-html="patient.HomeDesc" class="health-text"></p>
            </div>
            <div class="patient_health-right">
              <img :src="patient.docImage" alt class="home_health-image">
            </div>
          </div>
          <div class="patient_footnotes">
            <p class="patient-footnotes" v-html="sup_ml3 + patient.footnotes"></p>
          </div>
        </div>
        <div :class="['mobile-divider', 'mobile-divider_' + patient.name.toLowerCase()]"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax, TimelineMax, Power1 } from 'gsap';
import { mapState } from 'vuex'
import { gsap } from "gsap";

gsap.registerPlugin(gsap);

function insertAfter(referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export default {
  name: 'Home',
  data() {
    return {
      sup_ml3: '<sup class="ml-3">*</sup>',
      selected: ''
    }
  },
  computed: {
    ...mapState(['userAgent', 'patients']),
  },
  methods: {
    onSelectItem(slug) {
      return this.$router.push({ name: slug.charAt(0).toUpperCase() + slug.slice(1) });
    },
    onMouseEnter(e) {
      if (this.selected || this.$route.query.screentest) return;
      if (this.userAgent.window.width <= 1024 && this.userAgent.orientation !== 'landscape') return;
      e.target.classList.add('patient_hovered');
    },
    onMouseLeave(e) {
      if (this.userAgent.browser.name === 'safari' && this.userAgent.window.width > 1112) { // safari fix (button's incorrect animation)
        document.querySelectorAll('.patient_button').forEach(btn => {
          let counter = 0;
          let interval = setInterval(() => {
            btn.style.zIndex = counter;
            counter++;
            if (counter > 100) {
              clearInterval(interval);
              btn.style.zIndex = '';
            }
          }, 10)
        })
      }
      if (this.selected || this.$route.query.screentest) return;
      if (this.userAgent.window.width <= 1024 && this.userAgent.orientation !== 'landscape') return;
      e.target.classList.remove('patient_hovered');
    },
    enterHome() {
      if (this.$route.query.screentest) return true;
      let tl = new TimelineMax();
      if (this.userAgent.window.width > 1024 || (this.userAgent.window.width >= 1024 && Math.abs(window.orientation) === 90)) {
        tl.set(document.documentElement, { pointerEvents: 'none' });
        tl.staggerFrom('.patient_images', 1, { delay: 1, scale: 0, transformOrigin: 'center 32%' }, 0.25);
        tl.fromTo('.homepage-head', 1.5, { opacity: 0 }, { opacity: 1 }, 2);
        tl.fromTo('.patient_name', 1.5, { opacity: 0 }, { opacity: 1 }, 2);
        tl.fromTo('.patient_description', 1.5, { opacity: 0 }, { opacity: 1 }, 2);
        tl.fromTo('.patient_button', 1.5, { opacity: 0 }, { opacity: 1 }, 2);
        tl.fromTo('.patient_health', 1.5, { opacity: 0 }, { opacity: 1 }, 2);
        tl.fromTo('.patient_footnotes', 1.5, { opacity: 0 }, { opacity: 1 }, 2);
        tl.fromTo('.home_wrapper', 1, { opacity: 0 }, { opacity: 1 }, 1);
        tl.set(['.patient_images', '.homepage-head', '.patient_name', '.patient_description', '.patient_button', '.patient_health', '.patient_footnotes', '.home_wrapper', document.documentElement], { clearProps: 'all' });
      } else {
        tl.set(document.documentElement, { pointerEvents: 'none' }, 0);
        // tl.fromTo('.logo-app', 1, { opacity: 0, x: -50 }, { opacity: 1, x: 0 }, 0);
        tl.fromTo('.home_wrapper', 1, { opacity: 0, y: 50 }, { opacity: 1, y: 0 }, 0);
        tl.set(['.home_wrapper', document.documentElement], { clearProps: 'all' });
      }
    },
    attachHomeDivider() {
      var dividerWrapper = document.createElement('div');
      dividerWrapper.className = 'v-home-divider_container';
      dividerWrapper.classList.add('divider-1');
      var divider = document.createElement('div');
      divider.className = 'v-home-divider';
      var patient0 = document.querySelector('.patient_item-susan');
      dividerWrapper.appendChild(divider);
      insertAfter(patient0, dividerWrapper);
    },
    attachHomeDivider2() {
      var dividerWrapper = document.createElement('div');
      dividerWrapper.className = 'v-home-divider_container';
      dividerWrapper.classList.add('divider-2');
      var divider = document.createElement('div');
      divider.className = 'v-home-divider';
      var patient1 = document.querySelector('.patient_item-joseph');
      dividerWrapper.appendChild(divider);
      insertAfter(patient1, dividerWrapper);
    },
  },
  mounted() {
    this.enterHome();
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'section-view',
        'patient': 'home-screen',
        'section #': 'section-1'
      });
    }
    this.attachHomeDivider();
    this.attachHomeDivider2();
  },
  watch: {}
}
</script>

<style lang="scss">
.home_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-size: 100% 100%;
  background-image: url("../assets/img/homepage/homepage-bg.png");
  background-repeat: no-repeat;

  @include media(">=1600px") {
    align-items: center;
  }
  @include media("<tablet") {
    background-image: url("../assets/img/homepage/homepage-bg_mob.png");
  }

  @include media("<tablet") {
    height: auto;
    min-height: 100%;
  }
}

.patients-list {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  position: relative;

  @include media(">=1980px") {
    max-width: 1610px;
    background-size: cover;
  }

  @include media("<tablet") {
    flex-direction: column;
    background: none;
    position: static;
    float: none;
    width: auto;
    height: auto;
  }
}

.homepage-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 120px 0 120px;
  z-index: 9999;
  pointer-events: none;
  //
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: auto;

  .homepage-title {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 24px;
    font-weight: bold;
    font-stretch: condensed;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: center;
    color: #1c3460;
    text-transform: uppercase;
    @include media("<=largeTablet") {
      line-height: normal;
    }
  }

  @include media(">=1500px") {
    padding: 30px 20px 0 20px;
  }
  @include media("<tablet") {
    position: relative;
    padding: 85px 20px 20px 20px;
  }
}

.patient_item {
  background: no-repeat center bottom / 100%;
  cursor: pointer;
  width: 33.333%;
  height: 100%;
  float: left;
  position: absolute;
  top: 0;

  @include media(">=1980px") {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @include media('<=tablet') {
    position: initial;
    float: none;
    width: 100%;
    max-width: 370px;
    margin: 0 auto;
    height: auto;
    z-index: 1;
    top: 8%;
    padding-top: 0;
  }

  &-susan {
    left: 0;
    z-index: 3;
  }

  &-joseph {
    left: 33.333%;
    z-index: 2;
  }

  &-gabrielle {
    left: 66.666%;
    z-index: 1;
  }

  &__container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 70px 20px 20% 20px;
    align-items: center;
    @include media(">=1980px") {
      max-height: 620px;
    }
    @include media("<tablet") {
      padding: 20px 20px 40px 20px;
    }
    @include media("<=tablet", "landscape") {
      padding: 70px 17px 25px;
    }
  }

  &__image {
    width: 130px;
    height: 130px;
  }
}

.patient_images {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  height: auto;
  min-height: 150px;
  @include media("<=tablet") {
    align-items: center;
  }
}

.patient_circle {
  width: 100px;
  height: 100px;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0) scale3d(1, 1, 1);
  position: absolute;
  border-radius: 50%;
  transition: all 0.8s linear;
  background-color: rgba(255, 255, 255, 1);
  overflow: hidden;

  .patient_hovered & {
    transform: translate3d(-50%, -50%, 0) scale3d(5, 5, 1);
    //width: 500px;
    //height: 500px;
    background-color: rgba(255, 255, 255, 0);
  }
}

.patient_image {
  background-size: 120%;
  background-position-x: center;
  background-position-y: 60px;
  background-repeat: no-repeat;
  width: 560px;
  height: 560px;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0) scale3d(0.25, 0.25, 1);
  position: absolute;
  transition: all 0.8s linear;

  .patient_hovered & {
    background-size: 100%;
    transform: translate3d(-50%, -49.5%, 0) scale3d(0.125, 0.125, 1);
    //width: 280px;
    //height: 280px;

    .screentest & {
      background-position-y: 100px;
    }
  }

  &.patient_image-1 {
    background-position-y: 80px;

    .screentest & {
      background-position-y: 120px;
    }

    .patient_hovered & {
      background-size: 100%;
      transform: translate3d(-50%, -49.5%, 0) scale3d(0.125, 0.125, 1);
    }
  }
}

.patient_bg {
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 1s linear;
  background-image: linear-gradient(to top, #214c80 10%, rgba(255, 255, 255, 0) 100%);

  .patient_hovered & {
    opacity: 1;
  }
}

.patient_name {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0;
  z-index: 20;

  .patient-name {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 24px;
    font-weight: normal;
    font-stretch: condensed;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: center;
    color: #173a64;
    text-transform: uppercase;
    transition: all 0.5s ease-in-out;

    .patient_hovered & {
      color: #FFFFFF;
    }
  }

  @include media(">=1600px") {
    padding: 15px 0;
  }

  @include media("<=1400px") {
    padding: 5px;
  }

  @include media(">1100px", "height<840px") {
    padding: 5px;
  }
  @include media(">1100px", "height<760px") {
    padding: 0;
  }
}

.patient_description {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 50px 10px 50px;
  z-index: 20;
  min-height: 3em;

  .patient-description {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: center;
    color: #132c5a;
    transition: all 0.3s ease-in-out;

    .patient_hovered & {
      color: #FFFFFF;
    }
  }

  @include media("<=1400px") {
    padding: 0 40px 0 40px;
  }

  @include media("<=1235px") {
    padding: 0 20px;
    min-height: 45px;
  }

  @include media("<=1120px") {
    padding: 0;
  }

  @include media("<=1050px") {
    min-height: 55px;
  }

  @include media(">1100px", "height<840px") {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  @include media(">1100px", "height<760px") {
    padding-top: 0;
    padding-bottom: 0;
  }

  @include media("<tablet") {
    min-height: initial;
  }
}

.patient_button {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  z-index: 20;

  @include media(">=1600px") {
    padding: 10px 0 15px 0;
  }

  @include media(">1100px", "height<840px") {
    padding: 10px 0 10px 0;
  }

  @include media(">1100px", "height<760px") {
    padding: 5px;
  }

  .button-arrow {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .button {
    display: flex;
    width: auto;
    max-width: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-width 0.7s ease-in-out, opacity 1s ease-in-out;

    .patient_hovered & {
      max-width: 200px;
      opacity: 1;
      transition: max-width 0.7s ease-in-out, opacity 1s ease-in-out;
    }

    @include media("<tablet") {
      max-width: initial;
      opacity: 1;
    }
  }
}

.patient_health {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 5px 0 10px 0;
  z-index: 20;

  @include media(">=1600px") {
    justify-content: center;
  }

  &-left {
    display: flex;
    flex-direction: column;
    width: calc(100% - 73px);
    max-width: 300px;

    @include media("<=tablet") {
      max-width: 215px;
    }

    .health-text {
      font-family: 'Roboto Condensed', sans-serif;
      font-size: 13px;
      font-weight: normal;
      font-stretch: condensed;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: normal;
      text-align: right;
      color: #ffffff;

      b {
        font-weight: bold;
      }
    }
  }

  &-right {
    display: flex;
    flex-direction: column;

    .home_health-image {
      width: 100%;
      height: 100%;
      max-width: 62px;
      max-height: 73px;
      margin-left: 10px;
      @include media("<tablet") {
        max-width: 62px;
        max-height: 74px;
        margin-left: 15px;
      }
      @include media("<=tablet", "landscape") {
        margin-left: 15px;
      }
    }
  }

  @include media("<tablet") {
    justify-content: center;
    .patient_health-left {
      .health-text {
        color: #000000;
      }
    }
  }

  @include media("<=tablet", "landscape") {
    padding: 5px 10px;
  }

  @include media(">1100px", "height<840px") {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

.patient_footnotes {
  position: absolute;
  top: auto;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 20px 20px 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 20;

  @include media(">=1980px") {
    top: 100%;
  }
  @include media(">=1600px") {
    justify-content: center;
  }

  .patient-footnotes {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: condensed;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: normal;
    color: #ffffff;
    @include media(">=1600px") {
      text-align: center;
    }
    @include media("<tablet") {
      color: #000000;
    }
  }

  @include media("<tablet") {
    padding: 0 20px;
    bottom: 10px;
  }

  @include media("<=968px") {
    bottom: 20px;
  }

  @include media(">1100px", "height<840px") {
    padding-bottom: 10px;
  }

  @include media("<phone") {
    bottom: 25px;
  }
}

.v-home-divider_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  &.divider-1 {
    pointer-events: none;
    position: absolute;
    left: 33.33%;
  }

  &.divider-2 {
    pointer-events: none;
    position: absolute;
    left: 66.66%;
  }

  @include media("<tablet") {
    display: none;
    opacity: 0;
  }
}

.v-home-divider {
  height: 70%;
  border-right: solid 2px rgba(28, 52, 96, 0.17);
  @include media(">=1980px") {
    height: 50%;
  }
  @include media("<tablet") {
    height: 2px;
    width: calc(100% - 40px);
    margin: 0 auto;
    border-bottom: solid 2px rgba(28, 52, 96, 0.50);
  }
  @include media("<=tablet", "landscape") {
    height: 65%;
  }
}

.fadeSlow-leave-active {
  transition: opacity 0s;
}

.fadeSlow-enter-active {
  transition: opacity .5s;
  transition-delay: .5s;
}

.fadeSlow-enter, .fadeSlow-leave-to {
  opacity: 0;
}

.mobile-divider {
  display: none;
  position: absolute;
  height: 2px;
  background-color: rgba(28, 52, 96, 0.50);
  width: calc(100% - 40px);
  left: 20px;
  @include media("<tablet") {
    display: block;
  }
  @include media("<phone") {
    display: block;
  }
}

.mobile-divider_gabrielle {
  display: none;
}
</style>
